// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__39igV","right":"styles_right__2m2yM"};